import { render, staticRenderFns } from "./GameHome.vue?vue&type=template&id=bab3b954&scoped=true"
import script from "./GameHome.vue?vue&type=script&lang=js"
export * from "./GameHome.vue?vue&type=script&lang=js"
import style0 from "./GameHome.vue?vue&type=style&index=0&id=bab3b954&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab3b954",
  null
  
)

export default component.exports